import { BreadcrumbService } from './../services/breadcrumb.service';
import { PresenciaService } from './../services/presencia.service';
import { Colegio } from './../interfaces/colegio';
import { ClasesService } from './../services/clases.service';
import { ColegiosService } from './../services/colegios.service';
import { Router } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { UserService } from '../services/user.service';
import { AuthenticationService } from '../services/authentication.service';
import { Clases } from '../interfaces/clases';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-dash',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css'],
})
export class DashboardComponent implements OnInit {
  datosUsuario: any;
  colegio: Colegio;
  clase: Clases;
  userUid: any;
  misclases: any;
  nombres: string;
  apellidos: string;
  useravatar: string;
  breadcrumb = [];
  mainUserUidDb: string;
  rolUsuario: string;
  genero: string;
  cargado: boolean = false;

  profesoresId = [];
  profesores = [];
  lang: string;
  idColegio: string = '';
  nombreCurso = '';

  constructor(
    private translate: TranslateService,
    private userService: UserService,
    private authenticationService: AuthenticationService,
    private router: Router,
    private colegioService: ColegiosService,
    private clasesService: ClasesService,
    private breadService: BreadcrumbService
  ) {}

  private getUserName(user: any): string {
    return user?.nombrefalse || user?.name || user?.nombres || '';
  }

  private getUserLastName(user: any): string {
    return user?.apellidofalse || user?.last_name || user?.apellidos || '';
  }

  private getUserRole(user: any): string {
    return user?.role || user?.role || '';
  }

  private getUserGender(user: any): string {
    return user?.gender || user?.genero || '';
  }

  private getSchoolIds(user: any): string[] {
    return user?.schools || user?.colegios || [];
  }

  private getCourseIds(user: any): string[] {
    if (user?.courses) {
      return user.courses;
    }

    return (user?.cursos || []).map((course) => course?.uid || course?.id || course);
  }

  private getLegacyCourseName(user: any): string {
    const legacyCourse = user?.cursos?.[0];
    return legacyCourse?.name || legacyCourse?.nombre || '';
  }

  private getClassAdmins(classData: any): string[] {
    return classData?.admins || classData?.administradores || [];
  }

  private getDisplayName(user: any): string {
    return user?.name || user?.nombres || '';
  }

  ngOnInit() {
    if (localStorage.getItem('idioma')) {
      this.lang = localStorage.getItem('idioma');
      this.translate.setDefaultLang(this.lang);
      this.translate.use(this.lang);
    } else {
      this.translate.setDefaultLang('es');
      this.translate.use('es');
    }

    this.breadcrumb = this.breadService.getbread();
    const Userdata: any = this.userService.getUserinfodata();

    if (Userdata === undefined) {
      this.authenticationService.isAuth().subscribe((auth) => {
        if (auth) {
          this.userUid = auth.uid;

          this.userService.getUserById(this.userUid).subscribe((userdata) => {
            if (userdata[0].payload.doc.data()) {
              this.mainUserUidDb = userdata[0].payload.doc.id;

              this.datosUsuario = userdata[0].payload.doc.data();
              this.nombres = this.getUserName(this.datosUsuario);
              this.apellidos = this.getUserLastName(this.datosUsuario);
              this.useravatar = this.datosUsuario.avatar;
              this.rolUsuario = this.getUserRole(this.datosUsuario);
              this.genero = this.getUserGender(this.datosUsuario);
              this.nombreCurso = this.getLegacyCourseName(this.datosUsuario);

              const schoolIds = this.getSchoolIds(this.datosUsuario);
              if (schoolIds[0]) {
                this.colegioService
                  .getColegioById(schoolIds[0])
                  .subscribe(
                    (colegio) => {
                      if (colegio) {
                        this.colegio = colegio.payload.data();
                      }
                      this.cargado = true;
                    },
                    (error) => {
                      console.log(error);
                      this.cargado = true;
                    }
                  );

                this.clasesService
                  .getUserClass(this.userUid)
                  .subscribe((lasclases) => {
                    this.misclases = lasclases;
                    lasclases.forEach((admin) => {
                      const admins = this.getClassAdmins(admin.payload.doc.data());
                      if (admins.length > 0) {
                        this.profesoresId.push(
                          admins[0]
                        );
                      } else {
                        this.profesoresId.push('');
                      }
                    });

                    for (
                      let index = 0;
                      index < this.profesoresId.length;
                      index++
                    ) {
                      const element = this.profesoresId[index];
                      this.userService
                        .getUserById(element)
                        .subscribe((data) => {
                          data.forEach((us) => {
                            this.profesores[index] =
                              this.getDisplayName(us.payload.doc.data());
                          });
                        });
                    }
                  });
              }
            }
          });
        }
      });

      // this.getCurrentUser();
    } else {
      this.userUid = Userdata.payload.doc.data().uid;

      this.mainUserUidDb = Userdata.payload.doc.id;
      this.datosUsuario = Userdata.payload.doc.data();
      this.nombreCurso = this.getLegacyCourseName(this.datosUsuario);

      this.nombres = this.getUserName(this.datosUsuario);
      this.apellidos = this.getUserLastName(this.datosUsuario);

      this.useravatar = this.datosUsuario.avatar;
      this.rolUsuario = this.getUserRole(this.datosUsuario);
      this.genero = this.getUserGender(this.datosUsuario);

      const schoolIds = this.getSchoolIds(this.datosUsuario);
      if (schoolIds[0]) {
        this.colegioService
          .getColegioById(schoolIds[0])
          .subscribe(
            (colegio) => {
              if (colegio) {
                this.colegio = colegio.payload.data();
                this.cargado = true;
              }
            },
            (error) => {
              this.cargado = true;
              console.log(error);
            }
          );

        this.clasesService.getUserClass(this.userUid).subscribe((lasclases) => {
          this.misclases = lasclases;
          lasclases.forEach((admin) => {
            const admins = this.getClassAdmins(admin.payload.doc.data());
            this.profesoresId.push(
              admins[0] || ''
            );
          });

          for (let index = 0; index < this.profesoresId.length; index++) {
            const element = this.profesoresId[index];
            this.userService.getUserById(element).subscribe((data) => {
              data.forEach((us) => {
                this.profesores[index] = this.getDisplayName(us.payload.doc.data());
              });
            });
          }
        });
      }
    }
  }

  getCurrentUser() {
    this.authenticationService.isAuth().subscribe((auth) => {
      if (auth) {
        this.userUid = auth.uid;

        this.userService.getUserById(this.userUid).subscribe((userdata) => {
          if (userdata[0].payload.doc.data()) {
            this.mainUserUidDb = userdata[0].payload.doc.id;

            this.datosUsuario = userdata[0].payload.doc.data();
            this.nombres = this.datosUsuario.name;
            this.apellidos = this.datosUsuario.last_name;
            this.useravatar = this.datosUsuario.avatar;
            this.rolUsuario = this.datosUsuario.role;
            this.genero = this.datosUsuario.gender;

            if (this.datosUsuario.schools[0]) {
              this.colegioService
                .getColegioById(this.datosUsuario.schools[0])
                .subscribe(
                  (colegio) => {
                    if (colegio) {
                      this.colegio = colegio.payload.data();
                      this.cargado = true;
                    }
                  },
                  (error) => {
                    console.log(error);
                    this.cargado = true;
                  }
                );

              this.clasesService
                .getUserClass(this.userUid)
                .subscribe((lasclases) => {
                  this.misclases = lasclases;
                });
            }
          }
        });
      }
    });
  }

  UpdateBreadcrumb(name, url) {
    this.breadService.addtobread(name, url);
  }

  RemoveBreadcrumb(name) {
    this.breadService.removetobread(name);
    // this.router.navigate(['dashboard']);
  }

  irSala(clase) {
    let administradores = clase.payload?.doc.data().administradores;
    let sala = clase.payload?.doc.data().urlsala;
    console.log(sala);
    if (sala == null) {
      if (administradores.length > 0) {
        this.userService
          .getUserByIdNow(administradores[0])
          .subscribe((user) => {
            user.forEach((user2: any) => {
              let nombreTitle = this.toTitleCase(this.nombres);
              let apellidosTitle = this.toTitleCase(this.apellidos);

              window.open(
                'https://access.colegia.education/webapp3/#/?conference=' +
                  user2.data().username +
                  '&name=' +
                  nombreTitle +
                  ' ' +
                  apellidosTitle +
                  '&role=guest&callType=video&join=1'
              );
            });
          });
      }
    } else {
      window.open(
        //
        sala
      );
    }
  }

  getProfesores(clase) {
    let administradores = clase.payload?.doc.data().administradores;
    console.log(administradores);
  }

  toTitleCase(str) {
    return str.replace(/\w\S*/g, function (txt) {
      return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
    });
  }
}
